module.exports = __webpack_public_path__ + "static/truck-back-2e2fb7e8c2584cad6b0c3575686babfa.png";